module.exports = __webpack_public_path__ + "img/qr-code-test.768dc5ac.png";